import firebase from "firebase/app";
import { DeviceHeartRateData } from "@/entities/polar";

export async function validatePolarIdDuplication(deviceId: string): Promise<{
  isValidDeviceId: boolean;
}> {
  const _validatePolarIdDuplication = firebase
    .app()
    .functions("asia-northeast1")
    .httpsCallable("validate_polar_id_duplication");

  const res = await _validatePolarIdDuplication({ deviceId });
  return { isValidDeviceId: !(res.data.isDeviceIdUsed as boolean) };
}

export async function getHeartRateDataWithTimeRange(
  studentId: string,
  {
    from,
    to
  }: {
    from: number;
    to: number;
  }
) {
  const call = firebase
    .app()
    .functions("asia-northeast1")
    .httpsCallable("get_student_heart_rate_data");

  const res = await call({ from, to, studentId });

  return res.data.result as DeviceHeartRateData;
}

// 生徒問わず既存のデバイスIDを強制削除する強力な関数なので使用注意
export async function forceDeletePolarId(deviceId: string) {
  const call = firebase
    .app()
    .functions("asia-northeast1")
    .httpsCallable("force_delete_polar_id");

  const res = await call({ deviceId });

  if (!res.data.success) {
    throw new Error("unexpected error occurred");
  }

  return {
    ok: true
  };
}
